const HARP_RIDP_ERROR =
  '<strong>Unable to verify Profile Information (error code {errorCode})</strong>' +
  '<br> Reference Number:  <span class="ref-number">{experianReferenceId}</span>' +
  '<br><br>' +
  '<strong><u>We cannot verify your identity. Please check for errors in the information entered.</u></strong>' +
  '<ul>' +
  '  <li>If you recently changed your name, address, or phone number, you might need to use your prior information. </li>' +
  '  <li>Please enter information that is most likely to be directly associated with you - such as what is shown on your credit report or on your financial accounts. </li>' +
  '  <li> Do not use your work phone number or email in the personal phone number and email entries. </li>' +
  '</ul>' +
  '<br><br>' +
  'Experian was unable to verify the information you provided. There are two options to complete your registration.' +
  '<br><br>' +
  '<strong><u>Option 1: Retry Remote Proofing</u></strong>' +
  '<ol>' +
  '<li>If you think you know what you entered incorrectly and would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page' +
  '<a target="_self" href="{originUrl}/register/profile-info" > here.</a>' +
  '</li>' +
  '<li>Review and update your Profile Information. Experian may not have been able to verify your information for the following reasons:' +
  '<ul>' +
  '<li>You did not enter your legal name or you recently changed your name</li>' +
  '<li>You recently moved and changed your home address</li>' +
  '<li>You mistyped a required field (SSN, Date of Birth, etc.)</li>' +
  '</ul>' +
  '</li>' +
  '<li>Follow the steps to proceed.</li>' +
  '</ol>' +
  '<br>' +
  '<strong><u>Option 2: Call Experian to verify your identity</u></strong>' +
  '<ol>' +
  '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong> {experianReferenceId}</li>' +
  '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page' +
  '<a target="_self" href="{originUrl}/register/profile-info"> here.</a>' +
  '</li>' +
  '<li>Follow the steps to proceed.</li>' +
  '</ol>' +
  '<br>' +
  'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please ' +
  '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.';

const EXPERIAN_STOP_ERROR = `
  <strong>Unable to verify Profile Information (error code {errorCode})</strong><br />
  Reference Number:  {experianReferenceId}<br /><br />
  Experian was unable to verify the information you provided. Please review the following steps to complete registration.<br /><br />
  <strong><u>Call Experian to Verify Your Identity</u></strong>
  <ol>
    <li>If you think you have entered the correct information, please contact the Experian Call Center at <a href="tel:+1833-203-6550">1-833-203-6550</a> 
    and provide your <strong>Reference Number:</strong> {experianReferenceId}.</li>
    <li>If Experian is able to successfully identity proof you over the phone, select "<strong>Enter Reference Number</strong>" back on the 
    Profile information page <a target="_self" href="{originUrl}/register/profile-info">here</a>.</li>
    <li>Follow the steps to proceed.</li>
  </ol>
  <br />
  Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please 
  <a target="_blank" href="{originUrl}/login/contact">contact</a> the Services and Operations Support (SOS) team by phone <strong>1-866-288-8914</strong> or 
  email <strong>identity.proofing@cms.hhs.gov</strong>.
`;

export const RIDP_ERROR_MAP = Object.freeze({
  HARPEXPERIAN500: HARP_RIDP_ERROR,
  HARPEXPERIAN061: HARP_RIDP_ERROR,
  HARPEXPERIAN062: HARP_RIDP_ERROR,
  HARPEXPERIAN063: HARP_RIDP_ERROR,
  HARPEXPERIAN064: HARP_RIDP_ERROR,
  HARPEXPERIAN065: HARP_RIDP_ERROR,
  HARPEXPERIAN066: HARP_RIDP_ERROR,
  HARPEXPERIAN067: HARP_RIDP_ERROR,
  HARPEXPERIAN101: HARP_RIDP_ERROR,
  HARPEXPERIAN102: HARP_RIDP_ERROR,
  HARPEXPERIAN600: EXPERIAN_STOP_ERROR,

  '010':
    '<strong>Profile Information is associated with a minor (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'Your provided information is associated with a minor’s record. If you would like to dispute this report, please contact Experian.' +
    '<br><br> ' +
    '<strong><u>Call Experian to dispute this report</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to dispute this report,  please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId}</li> ' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info">here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br>' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  '018':
    '<strong>Information on the inquiry was reported as fraud by the consumer (error code {errorCode})' +
    '</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'The inquiry was reported as fraud, therefore Experian could not generate remote proofing questions. If you would like to dispute this report, please contact Experian.' +
    '<br><br> ' +
    '<strong><u>Call Experian to dispute this report</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to dispute this report,  please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId}</li> ' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info">here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br>' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  '092':
    '<strong>State legislation requires match on more identification information (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'Experian was unable to verify the information you provided. There are two options to complete your registration via remote proofing.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you think you know what you entered incorrectly and would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Review and update your Profile Information. Experian may not have been able to verify your information for the following reasons: ' +
    '<ul> ' +
    '<li>You did not enter your legal name or you recently changed your name</li> ' +
    '<li>You recently moved and changed your home address</li> ' +
    '<li>You mistyped a required field (SSN, Date of Birth, etc.) </li> ' +
    '</ul> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  106:
    '<strong>Invalid surname (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'Your provided surname is invalid. There are two options to complete your registration via remote proofing.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you think you know what you entered incorrectly and would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Review and update your Profile Information with the correct surname. You may have entered an invalid surname if you did not enter your legal name or you recently changed your name.</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  258:
    '<strong>Requested report unavailable at this time (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'The requested report is unavailable at this time. Please try again later.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <strong href="tel:18332036550">1-833-203-6550</strong> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  259:
    '<strong>Components of checkpoint system temporarily unavailable (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'The requested report is unavailable at this time. Please try again later.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  304:
    '<strong>NFD temporarily unavailable (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'The requested report is unavailable at this time. Please try again later.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  313:
    '<strong>NFD does not process inquiries with a Colorado ZIP code (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'NFD does not process inquiries with a Colorado ZIP code. Please contact Experian to verify your identity.' +
    '<br><br> ' +
    '<strong><u>Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info">here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  323:
    '<strong>Not all data available for Experian Detect evaluation (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'Experian was unable to verify the information you provided. There are two options to complete your registration via remote proofing.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you think you know what you entered incorrectly and would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Review and update your Profile Information. Experian may not have been able to verify your information for the following reasons: ' +
    '<ul> ' +
    '<li>You did not enter your legal name or you recently changed your name</li> ' +
    '<li>You recently moved and changed your home address</li> ' +
    '<li>You mistyped a required field (SSN, Date of Birth, etc.) </li> ' +
    '</ul> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  324:
    '<strong>Experian Detect temporarily unavailable (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'The requested report is unavailable at this time. Please try again later.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  352:
    '<strong>Precise ID system temporarily unavailable (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'The requested report is unavailable at this time. Please try again later.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  358:
    '<strong>Fraud Shield unavailable (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'The requested report is unavailable at this time. Please try again later.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  362:
    '<strong>Credit reporting temporarily unavailable (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'The requested report is unavailable at this time. Please try again later.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  403:
    '<strong>Invalid Social Security Number (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'Your provided Social Security Number (SSN) is invalid. There are two options to complete your registration via remote proofing.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Review and update your Profile Information with the correct SSN.</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  404:
    '<strong>Generation code required to access consumer’s file (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'Your generation code is required to access your file (Jr, Sr, I, II, III, etc.). Please contact Experian to verify your identity.' +
    '<br><br> ' +
    '<strong><u>Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info">here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  405:
    '<strong>Invalid Date of Birth (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'Your provided Date of Birth is invalid. There are two options to complete your registration via remote proofing.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Review and update your Profile Information with the correct Date of Birth.</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  406:
    '<strong>Middle name required (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'You need to enter your full middle name (not middle initial) to access your record. There are two options to complete your registration via remote proofing.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Review and update your Profile Information with your full middle name.</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  407:
    '<strong>Unable to standardize address (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'Your provided address is invalid. All addresses must be in U.S. Standard Postal Address format. ' +
    'Please see the USPS website <a target="_blank" href="https://tools.usps.com/go/zip-code.lookup.htm">here</a> for more information if you are unclear about this format. ' +
    'There are two options to complete your registration via remote proofing.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Review and update your Profile Information with the correct address. You may have entered an invalid address if you recently moved and changed your home address.</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  627:
    '<strong>Invalid address (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'Your provided address is invalid. All addresses must be in U.S. Standard Postal Address format. ' +
    'Please see the USPS website <a target="_blank" href="https://tools.usps.com/go/zip-code.lookup.htm">here</a> for more information if you are unclear about this format. ' +
    'There are two options to complete your registration via remote proofing.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Review and update your Profile Information with the correct address. You may have entered an invalid address if you recently moved and changed your home address.</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  633:
    '<strong>Address exceeds maximum length (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'Your provided address exceeds the maximum length (115 characters). There are two options to complete your registration via remote proofing.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Review and update your Profile Information with a shorter address, if possible.</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  708:
    '<strong>Input validation error (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'Your Profile Information contains an input validation error. There are two options to complete your registration via remote proofing.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Review and update your Profile Information to correct the input validation error.</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  709:
    '<strong>Invalid user ID/password (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'The requested report is unavailable at this time. Please try again later.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  710:
    '<strong>Session timeout (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'The requested report is unavailable at this time. Please try again later.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  711:
    '<strong>End user required (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'The requested report is unavailable at this time. Please try again later.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',

  720:
    '<strong>Precise ID system error (error code {errorCode})</strong>' +
    '<br>' +
    'Reference Number: {experianReferenceId}' +
    '<br><br> ' +
    'The requested report is unavailable at this time. Please try again later.' +
    '<br><br> ' +
    '<strong><u>Option 1: Retry Remote Proofing</u></strong> ' +
    '<ol> ' +
    '<li>If you would like to try again, please select <strong>"Retry Remote Proofing"</strong> back on the Profile Information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    '<strong><u>Option 2: Call Experian to verify your identity</u></strong> ' +
    '<ol> ' +
    '<li>If you think you have entered the correct information, please contact Experian Verification Support Services at <a href="tel:+1833-203-6550">1-833-203-6550</a> and provide your <strong>Reference Number: </strong>  {experianReferenceId} </li>' +
    '<li>If Experian is able to successfully identity proof you over the phone, select <strong>"Enter Reference Number"</strong> back on the Profile information page ' +
    '<a target="_self" href="{originUrl}/register/profile-info"> here.</a> ' +
    '</li> ' +
    '<li>Follow the steps to proceed.</li> ' +
    '</ol> ' +
    '<br> ' +
    'Detailed instructions have also been sent to your email address. If you need additional assistance completing registration, please  ' +
    '<a target="_blank" href="{originUrl}/login/contact">contact</a> your application’s help desk.',
});

export const ERR_INTERPOLATE = function (errorMap, props) {
  return errorMap.replace(/\{(\w+)\}/g, function (match, expr) {
    return props[expr];
  });
};
